export const GOOGLE_MAPS_LOADER_ID = 'google-map-script'

export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry' | 'routes')[] = [
  'places',
  'geometry',
  'routes',
]

export const getGoogleMapsApiKey = (): string =>
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

export const GOOGLE_MAPS_SCRIPT_LIBRARIES_PARAM = GOOGLE_MAPS_LIBRARIES.join(',')
